import classNames from 'classnames';

import { SnackbarType } from '../../types/enums';

import { ReactComponent as SuccessIcon } from './circle-check-solid.svg';
import { ReactComponent as ErrorIcon } from './circle-xmark-solid.svg';

import styles from './Snackbar.module.scss';

interface SnackbarProps {
  type: SnackbarType;
  children: React.ReactNode;
}

const Snackbar = ({ children, type }: SnackbarProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={classNames(styles.snackbar, styles[type])}>
        {type === SnackbarType.SUCCESS ? <SuccessIcon /> : <ErrorIcon />}
        {children}
      </div>
    </div>
  );
};

export default Snackbar;
